import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { DURATION_MS } from 'app/constants/CronTimes';
import { getUpgradeOffers } from './api';
import { UpgradeFeature, UpgradeOffers } from './types';
import { UPGRADE_OFFERS_QUERY_KEY } from './queryKeys';

type UseUpgradeOffersParams = {
  enabled: boolean;
};

type AuthUserState = {
  auth?: { user?: { id?: number } | null };
};

export function useUpgradeOffers(feature: UpgradeFeature, { enabled }: UseUpgradeOffersParams) {
  const userId = useSelector((state: AuthUserState) => state.auth?.user?.id);
  const { data, isLoading, isError } = useQuery<UpgradeOffers>({
    queryKey: [...UPGRADE_OFFERS_QUERY_KEY, feature, userId],
    queryFn: () => getUpgradeOffers(feature),
    enabled: enabled && userId != null,
    retry: false,
    staleTime: DURATION_MS.FIVE_MINUTES,
  });

  return { upgradeOffers: data, isLoading, isError };
}
